/**
 * Content source – all copy comes from JSON.
 * Default: /site-content.json (in public/). Override with REACT_APP_CONTENT_URL in .env.
 */
export const CONTENT_URL =
  process.env.REACT_APP_CONTENT_URL ||
  `${process.env.PUBLIC_URL || ''}/site-content.json`;
